// import Cookies from 'js-cookie';
import { SignUpModel } from '../models/models';
import { appNetworkManager } from './network-manager';

export const getUserProfile = () =>
  appNetworkManager.get('/userprofile', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });

export const postSignUp = (payload: SignUpModel) =>
  appNetworkManager.post(`/register`, {
    ...payload,
    user_mode: 'patient',
    email: null,
    password_confirmation: payload.password
  });

export const postSignIn = (mobileNumber: string, password: string) =>
  appNetworkManager.post(`/login`, {
    mobile_number: mobileNumber,
    password
  });

export const postRequestCode = (mobileNumber: string) =>
  appNetworkManager.post(`/requestcode`, {
    mobile_number: mobileNumber
  });

export const postConfirmCode = (
  mobileNumber: string,
  password: string,
  activationCode: string,
  type: 'otp' | 'reset'
) => {
  if (type === 'reset') {
    return appNetworkManager.post(`/resetpassword`, {
      mobile_number: mobileNumber,
      activation_code: activationCode,
      password_confirmation: password,
      password
    });
  }
  return appNetworkManager.post(`/confirmcode`, {
    mobile_number: mobileNumber,
    activation_code: activationCode,
    password
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const updateProfile = (payload: any) =>
  appNetworkManager.post(`/userprofileupdate`, payload, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });
export const preStartCheck = (uId: string) =>
  appNetworkManager.post(
    `/app_pre_start_check`,
    {
      version_code: 17,
      version_name: '',
      device_id: uId
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sendFeedback = (payload: any) => {
  const token = localStorage.getItem('token');
  if (token) {
    return appNetworkManager.post(`/send_feed_back`, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  } else {
    return appNetworkManager.post(`/send_feed_back_no_user`, payload);
  }
};
